import React from 'react';
import { history, replaceParam, RouteDefinitions } from 'routes';
import { Maybe, PetParentChannelFragment } from 'shared/types/graphql';
import styled from 'styled-components';
import { Center, Text, VStack } from '@televet/kibble-ui';
import PetParentConversationCard from 'shared/components/PetParentConversationCard';
import { useTracking } from 'shared/providers/TrackingProvider';
import { SidePanelClientProfileEvents } from 'shared/providers/TrackingProvider/EventNames';

interface ISidePanelConversationsSectionProps {
  channels: PetParentChannelFragment[];
  channelId: string;
  isMobile: boolean;
  setIsOpen: (isOpen: React.SetStateAction<boolean>) => void;
  isChannelsDataLoading: boolean;
  loadMoreChannels: () => void;
  allLoaded: boolean;
  isLoyaltyProgramEnabled?: boolean;
}

const SidePanelConversationsSection = ({
  channels,
  channelId,
  isMobile,
  setIsOpen,
  isChannelsDataLoading,
  loadMoreChannels,
  allLoaded,
  isLoyaltyProgramEnabled,
}: ISidePanelConversationsSectionProps): JSX.Element | null => {
  const { trackEvent } = useTracking();

  const handleCardClick = (channelId: string): void => {
    trackEvent(SidePanelClientProfileEvents.ViewConversation);
    if (isMobile) {
      setIsOpen(false);
    }
    history.push(replaceParam(RouteDefinitions.Conversations, ':channelId', channelId));
  };

  return (
    <VStack
      className="PetParentProfile__Conversations"
      py={4}
      bgColor={isLoyaltyProgramEnabled ? 'transparent' : 'background.subtle'}
      align="flex-start"
      px={5}
    >
      <Text as="p" fontWeight="bold" mb={2}>
        Conversations
      </Text>

      {channels.length ? (
        channels.map((channel) => {
          return (
            <PetParentConversationCard
              key={channel.id}
              channel={channel}
              isActive={channel.id === channelId}
              onCardClick={handleCardClick}
            />
          );
        })
      ) : (
        <Center py={3}>
          <Text size="sm">{isChannelsDataLoading ? 'Loading...' : 'There are no conversations with this client'}</Text>
        </Center>
      )}
      {!allLoaded && (
        <LoadMoreConversations onClick={loadMoreChannels}>
          <Text>Load more</Text>
        </LoadMoreConversations>
      )}
    </VStack>
  );
};

const LoadMoreConversations = styled.button`
  margin-bottom: 5px;
  width: 100%;
  :hover {
    text-decoration: underline;
  }
`;

const PetRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;

  font-weight: 600;
  font-size: 16px;
  padding: 8px 26px;
  cursor: pointer;
  opacity: ${(props: DeceasedState): string => (props.isDeceased ? '0.6' : '1')};
  &:hover {
    background: #f9f9f9;
  }
`;
interface DeceasedState {
  isDeceased: Maybe<boolean | undefined>;
}
PetRow.defaultProps = {
  isDeceased: false,
};

export default SidePanelConversationsSection;
